<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="fuel_consumption_row_right_section tank__bg"
          style="flex: 0 0 96.5%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-12">
              <div
                class="text-center transaction_period_text branch__sales__text"
                style="font-size: 22px; min-height: 200px"
              >
                <h3 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />
                  {{ $t("text.tankDetails.title") }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="mt-3 col-md-8" style="padding-right: 0px">
            <div class="drivers_list" style="height: 613px">
              <div
                class="product_summary__wrapper"
                style="padding: 10px; border-radius: 10px"
              >
                <div
                  class="mt-5 input__group__block"
                  style="width: 90%"
                  id="pdfContent"
                >
                  <highcharts
                    :options="tankStockForThePast7DaysSplineOptions"
                    class
                    v-if="!showLoader"
                  ></highcharts>
                  <div
                    class="showLoaderDiv charts__loader"
                    style
                    v-if="showLoader"
                  >
                    <div :class="showLoader ? 'loading' : null"></div>
                  </div>
                  <!-- <div class="mt-4 text-center">
                    <button v-if="!showLoader" class="show_more_button remove_text_decoration"  @click="downloadWithCSS">
                      Download Chart
                    </button>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-3 text-center col-md-4"
            style="padding-right: 0px !important; margin-bottom: 20px"
          >
            <div
              class="product_summary__wrapper tank__header__Wrapper"
              style="border-radius: 10px"
              v-show="!showLoader"
            >
              <!--  v-bind:style="{ '--vh': tankDetails.color, height: '10px' }"-->
              <div class="product_summary_header tank__header"></div>
              <h3 class="text-center tank__name">{{ tankDetails.name }}</h3>
              <div class="text-center flex___div">
                <small class="mt-3 time__stamps">
                  <img
                    src="@/assets/img/passage-of-time (1).png"
                    width-="18px"
                  />
                  {{
                    tankDetails.lastUpdate + " " + $t("text.tankDetails.ago")
                  }}
                </small>
                <div class="text-center bowl">
                  <div class="inner">
                    <div
                      class="fill"
                      v-bind:style="{
                        '--h': tankDetails.height + 'px',
                        '--c': tankDetails.waveColor,
                      }"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="300px"
                        height="300px"
                        viewBox="0 0 300 300"
                        enable-background="new 0 0 300 300"
                        xml:space="preserve"
                      >
                        <path
                          class="waveShape"
                          d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                        c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                        c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix mt-3 volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">
                    {{ $t("text.tankDetails.productVolume") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="litres">
                    {{ convertThousand(tankDetails.currentVolume) }}
                  </h4>
                </div>
              </div>
              <div class="clearfix volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">
                    {{ $t("text.tankDetails.tankCapacity") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="litres">
                    {{ convertThousand(tankDetails.maxCapacity) }}
                  </h4>
                </div>
              </div>
              <div class="clearfix volume_info">
                <div class="left_div">
                  <h4 class="vol_sold">
                    {{ $t("text.tankDetails.waterLevel") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="vol_sold">
                    {{ convertThousand(tankDetails.waterVolume) }}
                  </h4>
                </div>
              </div>
              <div class="pb-3 mt-3 tanks_probe">
                <div class="mt-4 mb-4">
                  <router-link
                    :to="{
                      name: 'tanks_probe_transactions',
                      query: {
                        branchId: $route.query.branchId,
                        tankId: this.$route.params.tankId,
                        companyId: $route.query.companyId,
                        dealerId: $route.query.dealerId,
                        groupId: $route.query.groupId,
                        regionId: $route.query.regionId,
                      },
                    }"
                    class="ml-4 probe_transactions_btn remove_text_decoration"
                    style="text-decoration: none"
                    >{{ $t("text.tankDetails.probeTransactions") }}</router-link
                  >
                </div>
                <div class="mb-3"></div>
              </div>
            </div>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <section class="pumps__list__wrapper">
        <h3 class="py-4 mt-4 text-center text-black">
          {{ $t("text.tankDetails.associatedPumps") }}
        </h3>

        <section class="pb-3 mt-3 products_summary__wrapper">
          <TableLoader :showLoader="showLoader" />
          <div class="row" style="margin-right: 0px" v-show="!showLoader">
            <div
              class="text-center col-md-4"
              v-for="(pump, index) in associatedPumps"
              :key="index"
              style="padding: 0px 15px !important; margin-bottom: 20px"
            >
              <div class="product_summary__wrapper tank__header__Wrapper">
                <div
                  class="product_summary_header tank__header"
                  v-bind:style="{ '--vh': pump.color, height: '10px' }"
                ></div>
                <h3 class="mt-3 text-center tank__name">{{ pump.name }}</h3>
                <div class="text-center flex___div">
                  <div class="mt-3 text-center">
                    <img src="@/assets/img/Group 806.png" />
                  </div>
                </div>
                <div class="clearfix mt-3 volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">
                      {{ $t("text.tankDetails.currentReading") }}
                    </h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">
                      {{ convertThousand(pump.currentReading) }}
                    </h4>
                  </div>
                </div>
                <div
                  class="pb-3 mt-4 tanks_probe"
                  style="display: flex; justify-content: space-evenly"
                >
                  <div class="mb-3 text-center">
                    <router-link
                      :to="{
                        path: `/Retail-Outlet/pump/transactions/${pump.id}`,
                        query: {
                          branchId: pump.id,
                          pumpId: $route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: $route.query.dealerId,
                          groupId: $route.query.groupId,
                          regionId: $route.query.regionId,
                        },
                      }"
                      class="probe_transactions_btn"
                      style="text-decoration: none"
                      >{{ $t("text.tankDetails.transactions") }}</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <PumpLoader :showLoader="showLoader"></PumpLoader> -->
        </section>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import PumpLoader from "@/components/PumpLoader/index";
import { Chart } from "highcharts-vue";
import VueHighcharts from "vue-highcharts";
import Highcharts from "highcharts";
import countryProducts from "@/products";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
  GridPlugin,
  RowDD,
  Selection,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
    Highcharts: Chart,
    PumpLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      backgroundUrl,

      branch: {},
      tanks: [],
      associatedPumps: [],
      pumps: [],
      tankDetails: [],
      branchId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      showLoader: false,
      showAll: false,
      tankStockForThePast7DaysSplineOptions: {
        chart: {
          type: "areaspline",
        },
        title: {
          text: this.$t("text.tankDetails.graphTitle"),
        },
        credits: {
          enabled: false,
        },

        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: true,
            },
            pointPlacement: "on",
          },
        },
        series: [],
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "left",
          verticalAlign: "bottom",
        },
        xAxis: {
          tickmarkPlacement: "on",
          labels: {
            enabled: true,
          },
          type: "datetime",
          startOnTick: true,
        },
        yAxis: {
          title: {
            text: this.$t("text.tankDetails.volumeLitres"),
          },
          labels: {
            enabled: true,
          },
        },
      },
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getPumps();
          this.getTankDetails();
          this.getTankWeeklyStockData();
        }
        this.groupProducts(this.pumps);
      }
    },
  },
  created() {
    document.title = "Tank Details: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Tank Details: ${branch.name} Retail Outlet`;
    });
    this.showLoader = true;
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},
  mounted() {
    if (this.branch.id !== null) {
      this.branchId = this.branch.id;
    }

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    getPumps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((element) => {
            if (element.productName !== undefined) {
              if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product1
              ) {
                element.color = "#d8991c";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product2
              ) {
                element.color = "#0fce29";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product3
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            } else if (element.displayName !== undefined) {
              if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product1)
              ) {
                element.color = "#d8991c";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product2)
              ) {
                element.color = "#0fce29";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3)
              ) {
                element.color = "#00aced";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product4)
              ) {
                element.color = "purple";
              }
            }
          });
          this.groupProducts(response.data);
          this.pumps = response.data;
          this.filterCount = response.data.length;
          this.pumpCount = response.data.length;
          localStorage.setItem("pumps", JSON.stringify(this.pumps));
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request) || request == undefined || request == null) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    groupProducts(pumpArray) {
      this.pumpsKeep = pumpArray;
      this.products = pumpArray.reduce((groups, product) => {
        const productName = product.productName;
        if (!groups) {
          groups = [];
        }
        if (!groups.includes(productName)) {
          groups.push(productName);
        }
        return groups;
      }, []);
    },
    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    changeRoute(route) {
      this.$router.push({ name: route });
    },
    getTankDetails() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/${this.$route.params.tankId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.waterVolume =
            response.data.waterVolume == null ? 0 : response.data.waterVolume;
          response.data.lastUpdate = this.timeSince(
            new Date(response.data.lastUpdate)
          );
          this.tankDetails = response.data;
          response.data.height = parseInt(
            150 -
              (response.data.currentVolume / response.data.maxCapacity) * 140
          );
          if (response.data.height >= 98) {
            response.data.waveColor = "red";
          } else if (response.data.height >= 70) {
            response.data.waveColor = "#039be4";
          } else {
            response.data.waveColor = "green";
          }
          if (
            response.data.productName.toLowerCase() ===
            this.countryProducts.productsLower.product1
          ) {
            response.data.color = "#d8991c";
            response.data.pumps.forEach((pump) => {
              pump.color = "#d8991c";
            });
          }
          if (
            response.data.productName.toLowerCase() ===
            this.countryProducts.productsLower.product3
          ) {
            response.data.color = "#00aced";
            response.data.pumps.forEach((pump) => {
              pump.color = "#00aced";
            });
          }
          if (
            response.data.productName.toLowerCase() ===
            this.countryProducts.productsLower.product2
          ) {
            response.data.color = "#0fce29";
            response.data.pumps.forEach((pump) => {
              pump.color = "#0fce29";
            });
          }
          if (
            response.data.productName.toLowerCase() ===
            this.countryProducts.productsLower.product4
          ) {
            response.data.color = "purple";
            response.data.pumps.forEach((pump) => {
              pump.color = "purple";
            });
          }
          this.showLoader = false;
          this.associatedPumps = response.data.pumps;
          this.tankDetails = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + " years";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    getTankWeeklyStockData() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/TankWeeklyProbe/${this.$route.params.tankId}`,
          configObject.authConfig()
        )
        .then((response) => {
          if (response.data.length > 0) {
            let splineData = response.data;
            let series = [];
            let productVolumeArray = [];
            response.data.forEach((element) => {
              productVolumeArray.push(element.productVolume);
            });

            series.push({
              name: this.$t("text.tankDetails.productVolume"),
              data: productVolumeArray,
              color: this.tankDetails.color,
            });

            let waterVolumeArray = [];
            response.data.forEach((element) => {
              waterVolumeArray.push(element.waterVolume);
            });
            series.push({
              name: this.$t("text.tankDetails.waterVolume"),
              data: waterVolumeArray,
              color: "#6f42c1",
            });
            const datesArr = [...Array(8)].map((_, i) => {
              const d = new Date();
              d.setDate(d.getDate() - i);
              return d;
            });
            let formattedDates = [];
            datesArr.forEach((date) => {
              formattedDates.push(
                this.$moment(date, "DD-MM-YYYY").format("MMMM D, YYYY")
              );
            });
            this.tankStockForThePast7DaysSplineOptions.xAxis.categories =
              formattedDates.reverse();
            this.tankStockForThePast7DaysSplineOptions.series = [...series];
            this.showLoader = false;
          }
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
